const validate = (values, language) => {
  // const { language } = props;

  const errors = {};
  if (!values.oldPassword) {
    errors.oldPassword = language.PasswordValidation.noOldPassword;
  }
  if (!values.newPassword) {
    errors.newPassword = language.PasswordValidation.noNewPassword;
  }
  if (!values.newPasswordVerification) {
    errors.newPasswordVerification =
      language.PasswordValidation.noNewPasswordVerification;
  } else if (values.newPassword !== values.newPasswordVerification) {
    errors.newPasswordVerification =
      language.PasswordValidation.passwordNotVerified;
  }

  return errors;
};

export default validate;
